import Api from 'services/Api';
import {validDate} from 'components/form/validator/validations';
import _ from 'lodash';

const mutationTypes = {
    UPDATE_VALUE: 'UPDATE_VALUE',
    RESET: 'RESET',
};
// There three of these?
const defaultPeriodTemplate = {
    periodStart: null,
    periodEnd: null,
    hoursPerDay: 1,
    rate: '',
    gratuitousCare: false,
    total: 0,
    table: [[]],
    includeLastDay: true,
    includeFirstDay: true
};

// Initial State
const state = {
    periods: [defaultPeriodTemplate],
    rates: {},
};

export function validRequest(period) {
    return (
        validDate(period.periodStart)
        && validDate(period.periodEnd)
        && period.hoursPerDay > 0
        && period.rate !== ''
        && period.periodStart < period.periodEnd
        && period.periodEnd > period.periodStart
    );
}

// Getters
const getters = {
    value: state => key => state[key],
    periods: state => state.periods
};

// Actions
const actions = {
    update({commit}, {key, value}) {
        commit(mutationTypes.UPDATE_VALUE, {key, value});
    },
    calculatePeriodTotal: _.debounce(({state, dispatch}, index) => {
        let period = state.periods[index];
        if (validRequest(period)) {
            Api.miniCalculators.care.findPeriods([period])
                .then(data => {
                    dispatch('update', {key: 'table', value: data});
                    period.table = data;
                    period.total = _(data[0]).reduce((total, item) => total +  item.total, 0);
                });
        }
    }, 500),
    loadCareRates({dispatch}) {
        return Api.miniCalculators.care.careRates()
            .then(data => dispatch('update', {key: 'rates', value: data}));
    },
    addPeriod({state}) {
        // Forth version of this, see above and templates.js
        state.periods.push({
            periodStart: null,
            periodEnd: null,
            hoursPerDay: 1,
            rate: '',
            gratuitousCare: false,
            total: 0,
            table: [[]],
            includeLastDay: true,
            includeFirstDay: true
        });
    },
    deletePeriod({state}, index) {
        state.periods.splice(index, 1);
    },
    updatePeriod({state}, {index, value}) {
        state.periods[index] = value;
    },
    reset({ commit }) {
        commit(mutationTypes.RESET);
    },
};

// Mutations
const mutations = {
    [mutationTypes.UPDATE_VALUE](state, payload) {
        state[payload.key] = payload.value;
    },
    [mutationTypes.RESET](state) {
        state.periods = [];
        state.periods.push({
            periodStart: null,
            periodEnd: null,
            hoursPerDay: 1,
            rate: '',
            gratuitousCare: false,
            total: 0,
            table: [[]],
            includeLastDay: true,
            includeFirstDay: true
        });
        state.rates = {};
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/mini/care.js